<template>
  <div class="quiz-container d-flex flex-column pa-7" style="position: relative; height: 100%;">


    <div class="d-flex align-center mb-3" :class="{'flex-wrap': $vuetify.breakpoint.xs}">




      <h1 class="headline ml-2 font-weight-bold mt-0" 
      style="flex: 1;"
      :class="{'mb-2': $vuetify.breakpoint.xs}">
        
        <v-btn icon class="quiz-header-button mx-1" small @click="$router.go(-1)">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

        {{ documentTitle.replace(/\.[^/.]+$/, '') }}
      </h1>


      <!-- <v-btn icon class="quiz-header-button mx-1" small @click="showSettings">
              <v-icon>mdi-cog-outline</v-icon>
            </v-btn> -->

      <div :class="{'w-100 d-flex justify-end mt-2': $vuetify.breakpoint.xs}">
        <v-btn color="#EEEDF1" class="ml-2 rounded-lg pl-4" style="color: #6E8071;" @click="printQuiz">

          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#6E8071"
            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="lucide mr-2 lucide-printer-icon lucide-printer">
            <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
            <path d="M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6" />
            <rect x="6" y="14" width="12" height="8" rx="1" />
          </svg>

          <span v-if="!$vuetify.breakpoint.xs">Imprimir</span>
        </v-btn>


        <v-btn class="primary mx-2 rounded-lg white--text" @click="shareQuiz">

          <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="mr-1 lucide lucide-users-icon lucide-users">
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
          </svg>

          <span v-if="!$vuetify.breakpoint.xs">Compartir</span>
        </v-btn>
      </div>

      <!-- <v-btn
              icon
              outlined
              color="#D9DDE8"
              class="rounded-lg"
              @click="$router.push('/app/document/' + documentId)"
            >
              <v-icon color="#606960">mdi-close</v-icon>    
            </v-btn> -->

    </div>

    <div v-if="isLoading" class="text-center my-12">
      <v-progress-circular indeterminate color="primary" :size="70" :width="7"></v-progress-circular>
      <p class="mt-4">Cargando cuestionario...</p>
    </div>

    <div v-else-if="error" class="text-center my-12">
      <v-alert type="error" outlined>
        {{ error }}
      </v-alert>
      <v-btn color="primary" class="mt-4" @click="fetchQuiz">
        Intentar de nuevo
      </v-btn>
    </div>

    <div v-else-if="!hasQuizContent" class="text-center my-12">
      <v-alert type="info" outlined>
        No se encontró contenido de cuestionario para este documento.
      </v-alert>
      <v-btn color="primary" class="mt-4" @click="generateQuiz">
        Generar cuestionario
      </v-btn>
    </div>

    <div v-else style="position: relative; flex: 1; max-width: 800px; width: 100%;" class="d-flex flex-column mx-auto">
      <!-- Modo de visualización pregunta por pregunta -->
      <quiz-single-question 
        :quiz="quiz" 
        :settings="settings" 
        :show-results-param="showResultsFromQuery" 
        :quiz-result-data="quizResultData"
        ref="quizComponent"
      ></quiz-single-question>

    </div>

    <!-- Diálogo de configuración -->
    <v-dialog v-model="settingsDialog" max-width="500px">
      <v-card>
        <v-card-title class="headline primary--text">
          Configuración del cuestionario
        </v-card-title>

        <v-card-text class="pt-4">
          <v-switch v-model="settings.shuffleQuestions" label="Mezclar preguntas" color="primary" hide-details
            class="mb-3"></v-switch>

          <v-switch v-model="settings.showExplanations" label="Mostrar explicaciones" color="primary" hide-details
            class="mb-3"></v-switch>

          <v-select v-model="settings.difficultyFilter" :items="difficultyOptions" label="Filtrar por dificultad"
            outlined dense class="mb-3"></v-select>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="settingsDialog = false">
            Cancelar
          </v-btn>
          <v-btn color="primary" @click="applySettings">
            Aplicar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de compartir -->
    <v-dialog v-model="shareDialog" max-width="500px">
      <v-card>
        <v-card-title class="headline primary--text">
          Compartir cuestionario
        </v-card-title>

        <v-card-text class="pt-4">
          <p>Selecciona cómo quieres compartir este cuestionario:</p>

          <v-text-field v-model="shareUrl" label="Enlace del cuestionario" readonly outlined
            append-icon="mdi-content-copy" @click:append="copyShareLink"></v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="shareDialog = false">
            Cerrar
          </v-btn>
          <v-btn color="primary" @click="copyShareLink">
            Copiar enlace
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import QuizSingleQuestion from '@/components/study/QuizSingleQuestion.vue';

export default {
  name: 'QuizView',
  components: {
    QuizSingleQuestion
  },
  data() {
    return {
      documentTitle: '',
      quiz: {
        multiple_choice: [],
        true_false: [],
        fill_in_the_blank: [],
        short_answer: [],
        matching_pairs: [],
        ordering: []
      },
      isLoading: true,
      error: null,
      documentId: this.$route.params.documentId,
      settingsDialog: false,
      settings: {
        shuffleQuestions: true,
        showExplanations: true,
        difficultyFilter: 'all'
      },
      difficultyOptions: [
        { text: 'Todas las dificultades', value: 'all' },
        { text: 'Fácil', value: 'easy' },
        { text: 'Media', value: 'medium' },
        { text: 'Difícil', value: 'hard' }
      ],
      shareDialog: false,
      shareUrl: '',
      showResultsFromQuery: false,
      quizResultData: {},
      quizId: null
    };
  },
  computed: {
    hasQuizContent() {
      return (
        (this.quiz.multiple_choice && this.quiz.multiple_choice.length > 0) ||
        (this.quiz.true_false && this.quiz.true_false.length > 0) ||
        (this.quiz.fill_in_the_blank && this.quiz.fill_in_the_blank.length > 0) ||
        (this.quiz.short_answer && this.quiz.short_answer.length > 0) ||
        (this.quiz.matching_pairs && this.quiz.matching_pairs.length > 0) ||
        (this.quiz.ordering && this.quiz.ordering.length > 0)
      );
    }
  },
  created() {
    // Comprobar si hay parámetros de consulta para mostrar resultados
    this.checkQueryParams();
    this.fetchQuiz();
  },
  methods: {
    checkQueryParams() {
      // Verificar si se debe mostrar resultados
      if (this.$route.query.show_results === 'true') {
        this.showResultsFromQuery = true;
        
        // Obtener el ID del quiz a mostrar
        if (this.$route.query.quiz_id) {
          this.quizId = this.$route.query.quiz_id;
          // Cargar los datos del quiz
          this.fetchQuizResult();
        }
      }
    },
    
    async fetchQuizResult() {
      if (!this.quizId) return;
      
      this.isLoading = true;
      
      try {
        const response = await this.axios.get(`/quiz-results/${this.quizId}`, {
          headers: {
            Authorization: this.$root.token.value
          }
        });
        
        if (response.data.success) {
          this.quizResultData = response.data.quizResult || {};
          // Actualizar el título del documento
          if (this.quizResultData.document_name) {
            this.documentTitle = this.quizResultData.document_name;
          }
          
          // Si no hay quiz, pero tenemos datos del resultado, prepararlos para mostrar
          if (!this.hasQuizContent && this.quizResultData.quiz_data && this.quizResultData.quiz_data.questions && this.quizResultData.quiz_data.questions.length > 0) {
            this.prepareQuizFromResults();
          }
        } else {
          this.error = response.data.error || 'No se pudo cargar el resultado del cuestionario';
        }
      } catch (err) {
        console.error('Error al cargar el resultado del cuestionario:', err);
        this.error = 'Error al cargar el resultado del cuestionario. Por favor, inténtalo de nuevo.';
      } finally {
        this.isLoading = false;
      }
    },
    
    prepareQuizFromResults() {
      // Si no hay quiz pero tenemos resultados, crear un objeto quiz con las preguntas de los resultados
      if (!this.quizResultData.quiz_data || !this.quizResultData.quiz_data.questions) return;
      
      const questionsByType = {
        multiple_choice: [],
        true_false: [],
        fill_in_the_blank: [],
        short_answer: []
      };
      
      // Agrupar preguntas por tipo
      this.quizResultData.quiz_data.questions.forEach(question => {
        if (question.type && questionsByType[question.type]) {
          questionsByType[question.type].push({
            question: question.question,
            answer: question.correct_answer,
            options: question.options || [],
            explanation: question.explanation || ''
          });
        }
      });
      
      // Asignar las preguntas agrupadas al quiz
      Object.keys(questionsByType).forEach(type => {
        if (questionsByType[type].length > 0) {
          this.quiz[type] = questionsByType[type];
        }
      });
    },
    
    async fetchQuiz() {
      // Si ya tenemos datos de un quiz anterior, no es necesario cargar el quiz normal
      if (this.showResultsFromQuery && this.quizResultData && Object.keys(this.quizResultData).length > 0) {
        return;
      }
      
      this.isLoading = true;
      this.error = null;

      try {
        const response = await this.axios.get(`/quiz/${this.documentId}`, {
          headers: {
            Authorization: this.$root.token.value
          }
        });

        if (response.data.success) {
          this.quiz = response.data.quiz || {};
          this.documentTitle = response.data.documentTitle || 'Cuestionario';
        } else {
          this.error = response.data.error || 'No se pudo cargar el cuestionario';
        }
      } catch (err) {
        console.error('Error al cargar el cuestionario:', err);
        this.error = 'Error al cargar el cuestionario. Por favor, inténtalo de nuevo.';
      } finally {
        this.isLoading = false;
      }
    },

    async generateQuiz() {
      this.isLoading = true;
      this.error = null;

      try {
        const response = await this.axios.post('/generate-quiz', {
          documentId: this.documentId,
          user_id: this.$root.currentUser.userId,
          language: this.$route.query.language || 'auto'
        }, {
          headers: {
            Authorization: this.$root.token.value
          }
        });

        if (response.data.success) {
          this.quiz = response.data.quiz || {};
          this.documentTitle = response.data.fileName || 'Cuestionario';
        } else {
          this.error = response.data.error || 'No se pudo generar el cuestionario';
        }
      } catch (err) {
        console.error('Error al generar el cuestionario:', err);
        this.error = 'Error al generar el cuestionario. Por favor, inténtalo de nuevo.';
      } finally {
        this.isLoading = false;
      }
    },

    async generateMoreQuestions() {
      this.isLoading = true;

      try {
        const response = await this.axios.post('/generate-more-quiz', {
          documentId: this.documentId,
          user_id: this.$root.currentUser.userId
        }, {
          headers: {
            Authorization: this.$root.token.value
          }
        });

        if (response.data.success && response.data.quiz) {
          // Combinar las preguntas nuevas con las existentes
          const newQuiz = response.data.quiz;
          Object.keys(newQuiz).forEach(key => {
            if (Array.isArray(newQuiz[key]) && Array.isArray(this.quiz[key])) {
              this.quiz[key] = [...this.quiz[key], ...newQuiz[key]];
            } else if (Array.isArray(newQuiz[key])) {
              this.quiz[key] = newQuiz[key];
            }
          });

          this.$toast.success('Se han generado nuevas preguntas');
        } else {
          this.$toast.error(response.data.error || 'No se pudieron generar más preguntas');
        }
      } catch (err) {
        console.error('Error al generar más preguntas:', err);
        this.$toast.error('Error al generar más preguntas. Por favor, inténtalo de nuevo.');
      } finally {
        this.isLoading = false;
      }
    },
    showSettings() {
      this.settingsDialog = true;
    },
    printQuiz() {
      // Crear un iframe oculto para la impresión
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      document.body.appendChild(iframe);

      // Preparar el contenido a imprimir
      const printContent = this.prepareQuizForPrint();

      // Acceder al documento del iframe
      const doc = iframe.contentWindow.document;
      doc.open();
      doc.write(`
        <html>
          <head>
            <title>Cuestionario: ${this.documentTitle}</title>
            <style>
              body { font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, Ubuntu, Arial, sans-serif; padding: 20px; }
              .question { margin-bottom: 20px; page-break-inside: avoid; }
              .question-text { font-weight: bold; margin-bottom: 10px; }
              .options { padding-left: 20px; }
              .option { margin-bottom: 5px; }
              h1 { color: #2d8930; }
              .header { 
                display: flex; 
                align-items: center; 
                justify-content: space-between; 
                margin-bottom: 20px; 
                border-bottom: 1px solid #eee; 
                padding-bottom: 15px; 
              }
              .logo { font-weight: bold; font-size: 24px; color: #4DD453; }
              .disclaimer { 
                margin-top: 30px; 
                font-size: 12px; 
                text-align: center; 
                color: #666; 
                border-top: 1px solid #eee; 
                padding-top: 15px; 
              }
            </style>
          </head>
          <body>
            <div class="header">
              <div class="logo">sele.ai</div>
              <div>Fecha: ${new Date().toLocaleDateString()}</div>
            </div>
            
            <h1>Cuestionario: ${this.documentTitle}</h1>
            ${printContent}
            
            <div class="disclaimer">
              Este cuestionario ha sido generado por sele.ai - La plataforma inteligente de estudio.
              <br>
              © ${new Date().getFullYear()} Sele - Todos los derechos reservados.
            </div>
          </body>
        </html>
      `);
      doc.close();

      // Imprimir cuando el iframe esté cargado
      iframe.onload = () => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();

        // Eliminar el iframe después de imprimir
        setTimeout(() => {
          document.body.removeChild(iframe);
        }, 1000);
      };
    },

    prepareQuizForPrint() {
      if (!this.hasQuizContent) return '<p>No hay preguntas disponibles para este cuestionario.</p>';

      let content = '';

      // Procesar preguntas de opción múltiple
      if (this.quiz.multiple_choice && this.quiz.multiple_choice.length > 0) {
        content += '<h2>Preguntas de opción múltiple</h2>';
        this.quiz.multiple_choice.forEach((question, index) => {
          content += `
            <div class="question">
              <div class="question-text">${index + 1}. ${question.question}</div>
              <div class="options">
                ${question.options.map(option => `<div class="option">- ${option}</div>`).join('')}
              </div>
            </div>
          `;
        });
      }

      // Procesar preguntas de verdadero/falso
      if (this.quiz.true_false && this.quiz.true_false.length > 0) {
        content += '<h2>Preguntas de verdadero/falso</h2>';
        this.quiz.true_false.forEach((question, index) => {
          content += `
            <div class="question">
              <div class="question-text">${index + 1}. ${question.question}</div>
              <div class="options">
                <div class="option">- Verdadero</div>
                <div class="option">- Falso</div>
              </div>
            </div>
          `;
        });
      }

      // Procesar preguntas de rellenar espacios
      if (this.quiz.fill_in_the_blank && this.quiz.fill_in_the_blank.length > 0) {
        content += '<h2>Preguntas de rellenar espacios</h2>';
        this.quiz.fill_in_the_blank.forEach((question, index) => {
          content += `
            <div class="question">
              <div class="question-text">${index + 1}. ${question.question}</div>
            </div>
          `;
        });
      }

      // Procesar preguntas de respuesta corta
      if (this.quiz.short_answer && this.quiz.short_answer.length > 0) {
        content += '<h2>Preguntas de respuesta corta</h2>';
        this.quiz.short_answer.forEach((question, index) => {
          content += `
            <div class="question">
              <div class="question-text">${index + 1}. ${question.question}</div>
            </div>
          `;
        });
      }

      return content;
    },

    shareQuiz() {
      // Mostrar el diálogo de compartir y preparar la URL
      this.shareUrl = `${window.location.origin}/app/quiz/${this.documentId}`;
      this.shareDialog = true;
    },

    copyShareLink() {
      navigator.clipboard.writeText(this.shareUrl).then(() => {
        this.$toast.success('Enlace copiado al portapapeles', {
          position: 'top-right',
          timeout: 3000
        });
      }).catch(err => {
        console.error('No se pudo copiar el enlace: ', err);
        this.$toast.error('No se pudo copiar el enlace', {
          position: 'top-right',
          timeout: 3000
        });
      });
    },
    applySettings() {
      this.settingsDialog = false;
      // Aplicar las configuraciones al cuestionario

      // Filtrar preguntas por dificultad
      let filteredQuiz = { ...this.quiz };

      if (this.settings.difficultyFilter !== 'all') {
        const difficulty = this.settings.difficultyFilter;

        // Filtrar cada tipo de pregunta por dificultad
        Object.keys(filteredQuiz).forEach(type => {
          if (Array.isArray(filteredQuiz[type])) {
            filteredQuiz[type] = filteredQuiz[type].filter(question =>
              question.level === difficulty || !question.level
            );
          }
        });
      }

      // Aplicar configuraciones al componente de cuestionario
      if (this.$refs.quizComponent) {
        // Pasar las configuraciones actualizadas
        this.$refs.quizComponent.applySettings(filteredQuiz, this.settings);

        this.$toast.success('Configuración aplicada', {
          position: 'top-right',
          timeout: 2000
        });
      }
    }
  }
};
</script>

<style scoped>
.quiz-container {
  min-height: 100vh;
  background-color: white;
}

.quiz-header-button {
  background-color: #f5f5f5;
  border-radius: 50%;
}

.quiz-share-button {
  font-weight: 500;
  letter-spacing: 0.5px;
  text-transform: none;
}
</style>